<template>
 <v-dialog v-model="dialogGroupName" persistent style="overflow-y: hidden;">
  <v-card >
  <v-card tile style="box-shadow: none !important;">
      <v-toolbar card style="background: #2562af !important;">
        <v-toolbar-title class="white--text CSChatThai">ชื่อกลุ่ม</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="closeDialog(false)">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="height: 30vh;
    overflow: scroll;">
    <v-text-field
              solo
              placeholder="ชื่อกลุ่ม"
              counter="40"
              height="35"
              v-model="Groupname"
            ></v-text-field>
<v-btn class="btnSave" small :disabled="(Groupname.length > 40)? true:false" @click="Save_Groupname()">บันทึก</v-btn>

    </v-card-text>

</v-card>
</v-dialog>
</template>
<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

const SET_GroupNAME = gql`
mutation ($room_id: uuid, $room_name: String) {
  update_room(where: {room_id: {_eq: $room_id}}, _set: {room_name: $room_name}) {
    returning {
      room_id
    }
  }
}
`

export default {
  props: {dialogGroupName: false, roomDetail_SepType: {}},
  data: () => ({
    user_id: '',
    Authorization: {},
    Groupname: ''
  }),
  created () {
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
  },
  watch: {
    dialogGroupName () {
      console.log(this.roomDetail_SepType.room.room_name)
      this.Groupname = this.roomDetail_SepType.room.room_name
    }
    // roomDetail_SepType () {
    //   console.log(this.roomDetail_SepType.room.room_name)
    //   // this.Groupname
    // }
  },
  methods: {
    closeDialog (stateChange) {
      this.$emit('closeEditGroupname', false, stateChange, this.Groupname)
    },
    Save_Groupname () {
      // this.$apollo.mutate({
      //   mutation: SET_GroupNAME,
      //   variables: {
      //     room_id: this.roomDetail_SepType.room_id,
      //     room_name: this.Groupname
      //   }
      // })
      var reqestBody = {
        "room_id": this.roomDetail_SepType.room_id,
        "new_group_name": this.Groupname
      }
      this.axios.post(process.env.VUE_APP_API + '/renameGroup', reqestBody, this.Authorization).then((response) => {
        this.closeDialog(true)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-dialog {
  width: 95vw;
  margin: 0 !important;
  box-shadow: none;
}

>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}

>>>.theme--light.v-input:not(.v-input--is-disabled) input {
    color: #2562af !important;
}


.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}


>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #f3f3f3 !important;
    border-radius: 5px !important;
    border: 2px solid #2562af !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
.btnSave {
  color: white !important;
  background: #2562af !important;
  box-shadow: none !important;
  margin: 20px auto !important;
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mail/Edit/edit_groupname.vue